import DropdownDialogWithPointerWrapper from '../../../components/DropdownDialogWithPointerWrapper'
import ApproversDialog from './ApproversDialog'

export default class ApproversDialogWrapper extends DropdownDialogWithPointerWrapper {
    constructor() {
        super({
            dialog: new ApproversDialog(),
            additionalClass: "approversDialogWrapper",
            dialogOffsets: {
                left: 45,
                top: 10
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/components/ApproversDialogWrapper.js